<div [ngClass]="messageSource ? 'location-chat-bubble-out' : 'location-chat-bubble-in'">
  @if (messageSource) {
    <app-read-receipt class="read-receipt" [messageStatus]="content['messageStatus']"></app-read-receipt>
  }
  <img class="location-image" [src]="content | getMapsImage" alt="maps view" />
  <div (click)="openMapsView()" class="overlay"></div>
  <div (click)="openMapsView()" class="image">
    <img src='../../../../../../../assets/svg/external-link.svg' />
  </div>
</div>
